// src/i18n.ts (ou .js)
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import i18nextHttpBackend from 'i18next-http-backend';
import i18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';

i18n
    // Utilise http-backend pour charger les fichiers JSON
    .use(i18nextHttpBackend)
    // (Optionnel) Détecte la langue du navigateur
    .use(i18nextBrowserLanguageDetector)
    // Permet l'intégration à react-i18next
    .use(initReactI18next)
    .init({
        // Où sont stockés vos JSON ?
        // par défaut, i18next-http-backend va chercher: /locales/{{lng}}/{{ns}}.json
        // si vous avez mis "public/locales", ça devrait marcher directement.

        backend: {
            // chemin par défaut : '/locales/{{lng}}/{{ns}}.json'
            // vous pouvez l'ajuster si nécessaire
            loadPath: '/locales/{{lng}}/{{ns}}.json'
        },

        // langues supportées
        supportedLngs: ['en', 'fr', 'es', 'de', 'it'],
        // namespace(s) disponibles
        // `report` : les libellés imprimés dans les PDF (story 7.3.2). Fourni en
        // fr, en et it — les trois langues que le produit sait produire
        // (ADR-0013) ; es et de retombent sur `fallbackLng`.
        ns: ['global', 'survey', 'locks', 'modules', 'report'],
        defaultNS: 'global',     // namespace par défaut
        fallbackLng: 'en',       // langue fallback
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
